<div class="admin-filters-wrapper">
  <div class="gt-filter-container">
    <div class="gt-filter-item">
      <i class="fa fa-refresh gt-refresh"
         [class.spinning]="loading"
         title="Refresh Data"
         role="button"
         tabindex="0"
         (click)="refresh()"
         (keydown.enter)="refresh()"
         (keydown.space)="refresh(); $event.preventDefault()"></i>
    </div>
    <div class="gt-filter-item">
      <div class="btn btn-success btn-xs" (click)="addScreen()">Add New Filter</div>
    </div>
    @if (clients.length > 1) {
<div class="gt-filter-item">
      <select class="gt-filter-select"
              [(ngModel)]="selectedClientKey"
              (ngModelChange)="onClientChange()">
        @for (c of clients; track $index) {
<option [ngValue]="c.client_key">
          {{ c.client_name || c.name || c.client_key }}
        </option>
}
      </select>
    </div>
}
  </div>

  <div adminGrid
       [gridConfig]="gridConfig"
       (gridCallback)="onGridCallback($event)"
       (gridDataLoaded)="onGridDataLoaded($event)"
       (loadingStateChange)="loading = $event"
       class="gizmo-grid"
       tabindex="2"></div>
</div>
